import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@klickdata/core/auth';
import { CustomerLanding } from '@klickdata/core/customer';
import { Utils } from '@klickdata/core/util';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
    public subdomain: string;
    public customerLanding$: Observable<CustomerLanding>;

    constructor(protected auth: AuthService, protected route: ActivatedRoute, protected router: Router) {
        this.subdomain = Utils.getSubdomain();
    }
    ngOnInit(): void {
        this.customerLanding$ = this.auth.getCustomerLanding();
    }
    public routeAfterLogin() {
        const uri = this.route.snapshot.queryParamMap.get('redirect_uri') || this.auth.homeUrl;
        this.router.navigateByUrl(uri);
    }
}
